import { EU_STORE_CONFIG } from "../../constants/static-constants";

export type RedirectType = "EU" | "ASOS" | null;

export const getRedirectType = (geoCountry: string | null): RedirectType => {
  if (!geoCountry || geoCountry === "GB") {
    return null;
  }

  const isEuCountry = EU_STORE_CONFIG.some(
    (country) => country.code === geoCountry,
  );

  if (isEuCountry) {
    return "EU";
  }

  return "ASOS";
};
